import useReports from "./hook/useReports";
import TableHeadings from '../../components/Common-components/table-headings'
import { Spinner } from '../../components/Common-components/spinner';
import TableContainer from "./component/tableContainer";
import moment from "moment-timezone";
import ReadMoreButton from "../../components/Common-components/ReadMoreLess";
import { useTranslation } from "react-i18next";
const PaymentRefund = () => {
    const {
        paymentRefundTableHead,
        details,
        loader,
        totalCount,
        controller,
        handlePagination,
    } = useReports();
    const { t } = useTranslation();
    return (
        <>
            {loader && <Spinner />}
            <TableContainer handlePagination={handlePagination} data={details} totalCount={totalCount} title={`${t("boxTitle.payment")} ${t("boxTitle.refund")}`} controller={controller}>
                <table className="table ">
                    <TableHeadings removeTr={true} TableHeadData={paymentRefundTableHead} />
                    <tbody>
                        {details?.map((cur, index) => (
                            <>
                                <tr className='fw-4 font-12' key={cur?._id} >
                                    <td>{cur?.bookingReferenceNumber}</td>
                                    <td>{cur?.clientName ?? "-"}</td>
                                    <td >{moment(cur?.createdAt).format("ll")}</td>
                                    <td><ReadMoreButton text={cur?.remarks} maxLength={100} /></td>
                                    <td>{cur?.amount ?? "-"}</td>
                                </tr>
                                <tr className='default_tr_gap'> </tr>
                            </>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </>

    )
}

export default PaymentRefund
